import { createGlobalStyle } from 'styled-components';
import {color, blockwidth, spacing, font, mq} from './variables';

export const GlobalStyle = createGlobalStyle`
  /*! normalize.css v8.0.0 | MIT License | github.com/necolas/normalize.css */
  html{line-height:1.15;-webkit-text-size-adjust:100%}body{margin:0}h1{font-size:2em;margin:.67em 0}hr{box-sizing:content-box;height:0;overflow:visible}pre{font-family:monospace,monospace;font-size:1em}a{background-color:transparent}abbr[title]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted}b,strong{font-weight:bolder}code,kbd,samp{font-family:monospace,monospace;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}img{border-style:none}button,input,optgroup,select,textarea{font-family:inherit;font-size:100%;line-height:1.15;margin:0}button,input{overflow:visible}button,select{text-transform:none}[type=button],[type=reset],[type=submit],button{-webkit-appearance:button}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{border-style:none;padding:0}[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring,button:-moz-focusring{outline:1px dotted ButtonText}fieldset{padding:.35em .75em .625em}legend{box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}progress{vertical-align:baseline}textarea{overflow:auto}[type=checkbox],[type=radio]{box-sizing:border-box;padding:0}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}details{display:block}summary{display:list-item}template{display:none}[hidden]{display:none} */

  html{
    font-size: 10%;
  }
  html, body{
    padding: 0;
    height: 100%;
    font-size: 15px;

    @media(min-width: ${mq.medium}px){
      font-size: 16px;
    }

  
  }

  * { box-sizing: border-box; margin: 0; }

  body {
    background-color: ${color.background};
    font-family: ${font.family.body};
    color: ${color.dark};
    -webkit-font-smoothing: antialiased;
    -moz-font-smoothing: antialiased;
    -ms-font-smoothing: antialiased;
    -o-font-smoothing: antialiased;
    font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-text-size-adjust: none;
    -ms-text-size-adjust: none;
    -o-text-size-adjust: none;
    text-size-adjust: none;
    line-height: 1.5;
    font-weight: 400;
   }

  img, iframe, video {
    width: 100%;
    display: block;
    height: auto;
  }

  a{
    color: ${color.primary};
  }

  .heading{
    font-family: ${font.family.heading};
    font-weight: ${font.weight.heading};
    margin: 0;
  }

  .heading-small{
    font-size: 1.175rem;
  }

  .heading-medium{
    font-size: 1.5rem;
    margin-bottom: ${spacing.xsmall}px;
  }

  .heading-large{
    font-size: 2.5rem;
    margin-bottom: ${spacing.small}px;
  }

  .body-small{
    font-size: ${font.size.body.small};
  }

  .center{
    text-align: center;
  }

  .full-width{
    width: 100%;
    max-width: 100%;
  }

  .flex-container{
    display: flex;
  }

  .flex-direction-row{
    flex-direction: row;
  }

  .flex-direction-column{
    flex-direction: column;
  }

  .no-bottom-margin{
    margin-bottom: 0;
  }

  .bullet-list{
    max-width: ${blockwidth.medium}px;
  }

  .bullet-list li{
    margin: 3px 0;
  }

  p{
    max-width: ${blockwidth.medium}px;
  }

  p+*:not(ul):not(div),
  ol+*,
  ul+*,
  blockquote+*,
  p+p, img+p {
    margin-top: 1.1em;
  }

  p + ul, ul + p{
    margin-top: 1.4em;
  }

  p.no-bottom-margin + ul{
    margin-top: 0;
  }

  p:last-child{
    margin-bottom: 0;
  }

  p + button, ul + button{
    margin-top: 2em;
  }

#dibs-complete-checkout iframe{
  height: 1200px;
  margin: 20px 0px;
}
`
